module.exports = __webpack_public_path__ + "img/ic_study.d4e0c611.png";